/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './ServiceBenefitsCard.scss';

import React from 'react';

import LinkButton from 'components/shared/Buttons/LinkButton';

import Optioner from 'components/shared/Optioner/Optioner';

import { ReactComponent as TurboTaxLogo } from 'assets/logo/logo-turbotax.svg';
import { ReactComponent as MorningStarLogo } from 'assets/logo/logo-morningstar.svg';
import { ReactComponent as WallStreetJournalLogo } from 'assets/logo/logo-wallstreetjournal.svg';

const ServiceBenefitsCard = ({ config }) => {
  const { benefitType, benefitContent, benefitUrl, newTab, className } = config;

  return (
    <div className="service-benefits-card">
      <Optioner val={benefitType}>
        {{
          turbotax: <TurboTaxLogo className="service-benefits-card-turbotax" />,
          morningstar: (
            <MorningStarLogo className="service-benefits-card-morningstar" />
          ),
          wallstreetjournal: (
            <WallStreetJournalLogo className="service-benefits-card-wallstreetjournal" />
          ),
          _: null
        }}
      </Optioner>
      <div className="service-benefits-card-content">{benefitContent}</div>
      <div className="service-benefits-card-link">
        <LinkButton
          text={'Visit'}
          link={benefitUrl}
          linkTarget={newTab ? '_blank' : '_self'}
          withPermissions={true}
          shouldDisable={true}
          className={`external-link-button ${className}`}
        />
      </div>
    </div>
  );
};

export default ServiceBenefitsCard;
